import React from "react"
import { Stack, Text } from "../../../vanilla"

  export const FieldWithSubText = ({
    children,
    subText,
    label,
    hasError
  }: {
    children: React.ReactNode
    subText?: string | string[]
    label?: string
    hasError: boolean
  }) => (
    <Stack spacing="8px">
      {label && (
      <Text variant="text1" color="textMuted">
        {label}
      </Text>
      )}
      {children}
      {subText && !hasError && (
        <Text variant="text1" color="textMuted">
          {subText}
        </Text>
      )}
    </Stack>
  )